<template>
  <div class="ic-modal-body">
    <h2 class="ic-modal-body__title">Edit Email Address</h2>
    <p v-if="errorBody" class="ic-modal-body__error-body" v-text="errorBody" />
    <form
      class="ic-modal-body__form"
      @submit="updateEmail"
      method="POST"
      autocomplete="on"
    >
      <div
        class="ic-modal-body__form-fields ic-modal-body__form-fields--full-width"
      >
        <div class="ic-modal-body__form-field">
          <label
            for="email"
            class="ic-modal-body__form-label"
            v-text="'Email Address'"
          />
          <input
            autocomplete="off"
            type="email"
            id="email"
            name="email"
            class="ic-modal-body__form-input"
            :class="{
              'ic-modal-body__form-input--error': error.email || errorBody
            }"
            v-model="form.email"
            @input="checkIfEmailsMatch"
          />
          <p class="ic-modal-body__error-message" v-if="message.email">
            {{ message.email }}
          </p>
        </div>
        <div class="ic-modal-body__form-field">
          <label
            for="confirmEmail"
            class="ic-modal-body__form-label"
            v-text="'Confirm Email Address'"
          />
          <input
            autocomplete="off"
            type="email"
            id="confirmEmail"
            name="confirm_email"
            class="ic-modal-body__form-input"
            :class="{
              'ic-modal-body__form-input--error':
                error.confirmEmail || errorBody
            }"
            v-model="form.confirmEmail"
            @input="checkIfEmailsMatch"
          />
        </div>
      </div>
      <div class="ic-modal-body__form-buttons">
        <button
          type="submit"
          class="ic-modal-body__form-button"
          :class="{ 'ic-modal-body__form-button--loading': isSubmitting }"
          v-text="submitButtonText"
          :disabled="!doEmailsMatch || isSubmitting"
        />
        <button
          class="ic-modal-body__form-button ic-modal-body__form-button--cancel"
          :disabled="isSubmitting"
          v-touch:tap="closeModal"
          v-text="cancelButtonText"
        />
      </div>
    </form>
  </div>
</template>

<script>
import helpers from '@/assets/js/shared/misc/helpers';

export default {
  name: 'ic-edit-email',
  props: {
    // Text to display for the submit button
    submitButtonText: {
      type: String,
      required: true
    },
    // Text to display for the cancel button
    cancelButtonText: {
      type: String,
      required: true
    },
    // Checks if form is being submitted
    isSubmitting: {
      type: Boolean,
      required: true
    },
    // Error message when endpoint fails
    errorBody: {
      type: String
    }
  },
  data() {
    return {
      form: {
        email: '',
        confirmEmail: ''
      },
      error: {
        email: false,
        confirmEmail: false
      },
      message: [],
      doEmailsMatch: false
    };
  },
  methods: {
    closeModal() {
      this.$emit('ic-edit-email-close-modal');
    },
    /**
     * Update button will remain disable until email and confirm email values match
     */
    checkIfEmailsMatch() {
      if (this.form.email === '' && this.form.confirmEmail === '') {
        this.doEmailsMatch = false;
        return;
      }

      this.doEmailsMatch = this.form.email === this.form.confirmEmail;
    },
    /**
     * Checks for email validation and confirmation before emitting event
     * @param event
     */
    updateEmail(event) {
      event.preventDefault();

      // Check if email is valid
      if (!helpers.emailRegex.test(this.form.email)) {
        this.error.email = true;
        this.error.confirmEmail = true;
        this.message['email'] = 'Invalid email address';

        return;
      }

      this.error.email = false;
      this.error.confirmEmail = false;
      this.message['email'] = '';

      this.$emit('ic-edit-email-update', this.form.confirmEmail);
    }
  }
};
</script>
